import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  GET_USER_PROFILE_URL,
  GET_FAMILY_PROFILE_URL,
  CHANGE_PASSWORD_URL,
  EDIT_PERSONAL_INFO_URL,
  GET_COUNTRIES_URL,
  ADD_COPARENT_URL,
  EDIT_COPARENT_URL,
  INVITE_COPARENT_URL,
  CANCEL_INVITATION_COPARENT_URL,
  ADD_CHILD_URL,
  EDIT_CHILD_URL,
  DELETE_COPARENT_URL,
  DELETE_CHILD_URL,
  DELETE_ACCOUNT_URL,
  VERIFY_PHONE_NUMBER_ON_PROFILE_URL
} from '@/constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.GET_USER_PROFILE]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(GET_USER_PROFILE_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_FAMILY_PROFILE]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(GET_FAMILY_PROFILE_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.CHANGE_PASSWORD]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(CHANGE_PASSWORD_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.EDIT_PERSONAL_INFO]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(EDIT_PERSONAL_INFO_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_COUNTRIES]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
        .get(GET_COUNTRIES_URL)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.ADD_COPARENT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(ADD_COPARENT_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.EDIT_COPARENT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(EDIT_COPARENT_URL.replace(':guid', data.guid), data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.SEND_INVITITATION_COPARENT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(INVITE_COPARENT_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.RESEND_INVITITATION_COPARENT]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .putData(INVITE_COPARENT_URL, data)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.CANCEL_INVITATION_COPARENT]({ commit }, guid) {
    return new Promise((resolve, reject) => {
      ApiService
          .delete(CANCEL_INVITATION_COPARENT_URL.replace(':guid', guid))
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.DELETE_COPARENT]({ commit }, guid) {
    return new Promise((resolve, reject) => {
      ApiService
        .delete(DELETE_COPARENT_URL.replace(':guid', guid))
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.VERIFY_PHONE_NUMBER_ON_PROFILE]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
          .post(VERIFY_PHONE_NUMBER_ON_PROFILE_URL, data)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
  [action.ADD_CHILD]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .post(ADD_CHILD_URL, data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.EDIT_CHILD]({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService
        .putData(EDIT_CHILD_URL.replace(':guid', data.guid), data)
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.DELETE_CHILD]({ commit }, guid) {
    return new Promise((resolve, reject) => {
      ApiService
        .delete(DELETE_CHILD_URL.replace(':guid', guid))
        .then((response) => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.DELETE_ACCOUNT]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
          .delete(DELETE_ACCOUNT_URL)
          .then((response) => {
            return resolve(response)
          })
          .catch(error => {
            return reject(error)
          })
    })
  },
}

export default {
  state,
  actions,
  getters
}
